<template>
    <section class="d-flex  hv-10">
        <sidebar-menu :menu="menu"  @update:collapsed="isCollapsed = !isCollapsed" >
            <template v-slot:toggle-icon>
                <font-awesome-icon icon="fa-solid fa-arrow-left" style="width:20px" v-if="!isCollapsed" />
                <font-awesome-icon icon="fa-solid fa-arrow-right" style="width:20px" v-else />
            </template>
             <slot name="header" />
        </sidebar-menu>
        <div class="flex-1 right-area-content" :style="!isCollapsed ? 'padding-left:290px' : 'padding-left:65px'">
            
            <TheHeader/>
            
            <div class="content">
                <el-breadcrumb separator="/" class="router-breadcrumb d-flex mb-20 text-cap">
                    <router-link to="/" class="mx-5 no-decoration">
                        <span class="font-20 text-theme ">
                            <font-awesome-icon :icon="['fas', 'house']"  class="font-20" style="width:20px"/>&nbsp;
                        </span>
                    </router-link>
                    <el-breadcrumb-item v-for="route in $route.matched"  :to="route.path" :key="route.path">
                        {{route.name ? route.name.replaceAll('-',' ') : ''}}
                    </el-breadcrumb-item>
                </el-breadcrumb>
                <router-view></router-view>
            </div>
        </div>
    </section>
</template>
<script>
import TheHeader from '../../components/TheHeader.vue';
export default {
    components: { TheHeader },
    computed:{
        cachedUser(){
            // 
            return JSON.parse(localStorage.getItem('adminStore'))?.admin.user || {}

        }
    },

    data() {
        return {
            routes:[],
            isCollapsed:false,
            menu: [
                {
                    header: "Main Navigation",
                    hiddenOnCollapse: true,
                },
                {
                    // href: "/",
                    title: "Website Management",
                    icon: "icon-website",
                    child: [
                        {
                            // icon: "icon-website",
                            title: "home page",
                            child:[
                                {
                                    href: "/website/home-page/home-facts",
                                    // icon: "icon-website",
                                    title: "home facts",
                                },
                                {
                                    href: "/website/home-page/home-video",
                                    // icon: "icon-website",
                                    title: "home video",
                                },
                                
                                {
                                    href: "/website/home-page/home-testimonials",
                                    // icon: "icon-website",
                                    title: "home testimonials",
                                },
                                {
                                    href: "/website/home-page/home-quotes",
                                    // icon: "icon-website",
                                    title: "home quotes",
                                }
                            ]
                        },
                        {
                            // icon: "icon-website",
                            title: "partners",
                            child:[
                                {
                                    href: "/website/partners",
                                    // icon: "icon-website",
                                    title: "partners list",
                                },
                            ]
                        },
                        {
                            
                            // icon: "icon-website",
                            title: "aboutus",
                            child:[
                                {
                                    href: "/website/aboutus/values/values-list",
                                    // icon: "icon-website",
                                    title: "our values",
                                },
                                {
                                    href: "/website/aboutus/stories/stories-list",
                                    // icon: "icon-website",
                                    title: "our stories",
                                },
                            ]
                        },
                        {
                            
                            // icon: "icon-website",
                            title: "services",
                            child:[
                                {
                                    href: "/website/services/services-list",
                                    // icon: "icon-website",
                                    title: "services list",
                                },
                                {
                                    href: "/website/services/photos-list",
                                    // icon: "icon-website",
                                    title: "Coverage Photo list",
                                },
                            ]
                        },
                        {
                            // icon: "icon-website",
                            title: "contact page",
                            child:[
                                {
                                    href: "/website/contact-page/contact-art",
                                    // icon: "icon-website",
                                    title: "contact art",
                                },
                                {
                                    href: "/website/contact-page/contact-fields",
                                    // icon: "icon-website",
                                    title: "contact fields",
                                },
                                
                            ]
                        },
                        {
                            // icon: "icon-website",
                            title: "careers page",
                            child:[
                                {
                                    href: "/website/careers-page/careers-art",
                                    // icon: "icon-website",
                                    title: "careers art",
                                },
                                {
                                    href: "/website/careers-page/careers-fields",
                                    // icon: "icon-website",
                                    title: "careers fields",
                                },
                                {
                                    href: "/website/careers-page/careers-departments",
                                    // icon: "icon-website",
                                    title: "careers departments",
                                },
                            ]
                        },
                        {
                            
                            // icon: "icon-website",
                            title: "settings",
                            child:[
                                {
                                    href: "/website/settings/pages-banners-list",
                                    // icon: "icon-website",
                                    title: "pages banners list",
                                },
                                {
                                    href: "/website/settings/sections-headers-list",
                                    // icon: "icon-website",
                                    title: "pages sections list",
                                },
                                {
                                    href: "/website/settings/logos/logos-list",
                                    // icon: "icon-website",
                                    title: "logos list",
                                },
                                {
                                    href: "/website/settings/seo/seo-list",
                                    // icon: "icon-website",
                                    title: "seo list",
                                },
                                {
                                    // icon: "icon-website",
                                    title: "footer",
                                    child:[
                                        {
                                            href: "/website/settings/footer/footer-photos/footer-photos-list",
                                            // icon: "icon-website",
                                            title: "footer photos list",
                                        },
                                        {
                                            href: "/website/settings/footer/footer-branches/footer-branches-list",
                                            // icon: "icon-website",
                                            title: "footer branches list",
                                        },
                                        {
                                            href: "/website/settings/footer/footer-paragraphs/footer-paragraphs-list",
                                            // icon: "icon-website",
                                            title: "footer paragraphs list",
                                        },
                                        {
                                            href: "/website/settings/footer/footer-socials/footer-socials-list",
                                            // icon: "icon-website",
                                            title: "footer social media list",
                                        },
                                        {
                                            href: "/website/settings/footer/footer-contacts/footer-contacts-list",
                                            // icon: "icon-website",
                                            title: "footer contacts  list",
                                        },
                                        
                                    ]
                                },
                            ]
                        },
                        
                    ],
                },
                // {
                //     title: "Admin Panel",
                //     icon: "icon-admin",
                //     id:'usersManagement',
                //     // child: [
                //     //     {
                //     //         href: "/admin-panel/inbox-management",
                //     //         title: "inbox",
                //     //     },
                        
                //     // ],
                // },
            ],
        };
    },
    mounted(){
        // if(this.cachedUser.userType == 'SUPER_ADMIN') {
        //     const userManagementRoute = this.menu.find(item => item.id == 'usersManagement');
        //     if(userManagementRoute){
        //         userManagementRoute.child.unshift(
        //             {
        //                 href: "/admin-panel/users/users-list",
        //                 title: "users management",
        //             }
        //         )
        //     }
        // }
       
    },
    methods:{
        getRoutes(){
            this.$router.options.routes.forEach(route => {
                this.routes.push({
                    name: route.name,
                    href: route.path,
                    child: route.children
                })
            })
        }
    }
};
</script>
<style lang="scss">
    
    .hv-100{
        height: 100vh;
    }
    .content{
        padding: 30px;
    }
    .right-area-content{
        transition: all 0.3s;
    }
</style>